import Component from "~/route-containers/partner/products.container";
import { MetaFunction } from "@remix-run/node";
import { productsLoader } from "~/loaders/products.loader";
import { ShouldRevalidateFunction } from "@remix-run/react";
import { getUrlCanonical } from "@commons-monorepo/index";

export const meta: MetaFunction = ({ matches, location }) => {
  const { search } = location;
  const paginatedData = matches[2]?.data?.paginatedData.products;
  const { partnerId } = matches[2]?.params;
  const parentsData = matches[0]?.data;
  const storeMetadata = parentsData?.storeMetadata;
  const city = storeMetadata?.storeCity;
  const description = storeMetadata?.description;
  const formattedDescription =
    description && description.length > 160
      ? description.slice(0, 160) + "..."
      : description;
  const canonical = getUrlCanonical(parentsData);
  const partnerProfilePicture =
    (storeMetadata?.profilePicConfiguration?.enableSquare &&
      storeMetadata?.profilePicConfiguration?.squareImage) ||
    (storeMetadata?.profilePicConfiguration?.enableRectangle &&
      storeMetadata?.profilePicConfiguration?.rectangleImage) ||
    storeMetadata?.profilePic ||
    "";

  const facebookMetadata = storeMetadata?.configuration?.facebookMetadata;
  const facebookMetaContent =
    facebookMetadata?.match(/content="(.*)"/) ||
    facebookMetadata?.match(/content="(.*)"/);
  const resultMatchFacebook = facebookMetaContent && facebookMetaContent[1];

  const page = new URLSearchParams(search).get("page");
  const title =
    page && page !== "1"
      ? `${paginatedData?.[0]?.name} en ${city} y productos similares - ${partnerId}`
      : storeMetadata?.enterpriseName;

  return [
    {
      title,
    },
    { name: "description", content: formattedDescription },
    {
      name: "viewport",
      content: "width=device-width,initial-scale=1,maximum-scale=1",
    },
    {
      name: "og:title",
      content: storeMetadata?.enterpriseName || "Catálogo de productos",
    },
    { name: "og:image", content: partnerProfilePicture },
    { name: "og:description", content: description },
    { name: "facebook-domain-verification", content: resultMatchFacebook },
    {
      tagName: "link",
      rel: "canonical",
      href: canonical,
    },
  ];
};

export const shouldRevalidate: ShouldRevalidateFunction = ({
  currentParams,
  currentUrl,
  defaultShouldRevalidate,
  nextParams,
  nextUrl,
}) => {
  if (
    currentParams.partnerId === nextParams.partnerId &&
    currentUrl.searchParams.toString() === nextUrl.searchParams.toString()
  ) {
    return false;
  }

  return defaultShouldRevalidate;
};

export { productsLoader as loader };

export default Component;
